// extracted by mini-css-extract-plugin
export default {"table":"transaction-preview-view_table__eBSSb","row":"transaction-preview-view_row__mTjDf","rowBold":"transaction-preview-view_rowBold__oQd+h"};